export default "__VITE_ASSET__BjruBndP__"